module.exports = __webpack_public_path__ + "static/White-d7515fb97b4da911e58e4c1f491753db.png";